/* Hook encargado de hacer la consulta a la base y 
traer la cotizacion a partir de su id

Autor: Benjamín León
Fecha: 2024-08-16
*/
import { useState } from 'react'

import ConsignmentDet from '../interfaces/ConsignmentDet.ts'
import { fechaIsoToYYYY_MM_DD } from '../utils/utils.ts'
import { customFetch } from '../utils/customFetch.ts'
import Consignment from '../interfaces/Consignment.ts'

import { makeUrlConsignment, makeUrlConsignmentDb, makeUrlConsignmentVehicle } from './connectionData.tsx'

export const useConsignmentFetcher = () => {
  const [errorConsignment, setErrorConsignment] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  /*
  Trae los datos básicos de la consignación
  */

  const fetchConsignmentDtoWithId = async (id: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlConsignmentDb(id)
      const data = await customFetch<Consignment>(apiUrl)
      setErrorConsignment(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorConsignment(err)
      } else {
        setErrorConsignment(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  const fetchConsignment = async (id: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlConsignment(id)
      const consig = await customFetch<ConsignmentDet>(apiUrl)
      consig.date = fechaIsoToYYYY_MM_DD(consig.date)

      if (consig.vehicle.documents) {
        consig.vehicle.documents.checkup = fechaIsoToYYYY_MM_DD(consig.vehicle.documents.checkup)
      } else {
        consig.vehicle.documents = { checkup: '', insurance: '', permit: '' } as any
      }

      setErrorConsignment(null)

      return consig
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorConsignment(err)
      } else {
        setErrorConsignment(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  const fetchConsignmentVehicle = async (vehicleId: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlConsignmentVehicle(vehicleId)
      const consig = await customFetch<Consignment>(apiUrl)
      setErrorConsignment(null)

      return consig
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorConsignment(err)
      } else {
        setErrorConsignment(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorConsignment, loading, fetchConsignment, fetchConsignmentDtoWithId, fetchConsignmentVehicle }
}
